import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight, FaFrown } from 'react-icons/fa';

// To test the "no jobs" state, you can make this array empty:
// const mockJobs = [];
const mockJobs = [
    { id: 1, title: 'Senior Frontend Developer', company: 'Tech Solutions Inc.', location: 'Remote', type: 'Full-time' },
    { id: 2, title: 'UX/UI Designer', company: 'Creative Minds LLC', location: 'New York, NY', type: 'Full-time' },
    { id: 3, title: 'Backend Engineer (Python)', company: 'Data Systems Co.', location: 'San Francisco, CA', type: 'Full-time' },
    { id: 4, title: 'Product Manager', company: 'Innovate Hub', location: 'Austin, TX', type: 'Full-time' },
    { id: 5, title: 'DevOps Engineer', company: 'CloudFirst', location: 'Remote', type: 'Contract' },
    { id: 6, title: 'Data Scientist', company: 'Analytics Corp', location: 'Chicago, IL', type: 'Full-time' },
];

const JOBS_PER_PAGE = 2;

const LatestJobs = () => {
    const [currentPage, setCurrentPage] = useState(0);

    const totalPages = Math.ceil(mockJobs.length / JOBS_PER_PAGE);

    const handlePrev = () => {
        setCurrentPage((prev) => (prev === 0 ? totalPages - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentPage((prev) => (prev === totalPages - 1 ? 0 : prev + 1));
    };

    const paginatedJobs = mockJobs.slice(
        currentPage * JOBS_PER_PAGE,
        (currentPage + 1) * JOBS_PER_PAGE
    );

    return (
        <section className="bg-cyan-600 rounded-2xl my-20">
            <div className="container mx-auto px-6 py-12">
                <div className="flex flex-col lg:flex-row gap-8">
                    {/* Left Column */}
                    <div className="lg:w-1/3 text-white">
                        <article className="mb-8">
                            <h2 className="text-4xl font-bold mb-4">Better Jobs<br />start here</h2>
                            <p className="text-cyan-100">
                                Your connection to a better job and career opportunity start here. Find jobs and remote work opportunities with companies that care.
                            </p>
                        </article>
                        <div className="slider-nav flex gap-x-3">
                            <button onClick={handlePrev} className="bg-yellow-500 hover:bg-yellow-400 text-white w-12 h-12 rounded-full flex items-center justify-center transition-colors">
                                <FaArrowLeft />
                            </button>
                            <button onClick={handleNext} className="bg-yellow-500 hover:bg-yellow-400 text-white w-12 h-12 rounded-full flex items-center justify-center transition-colors">
                                <FaArrowRight />
                            </button>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="lg:w-2/3">
                        {mockJobs.length === 0 ? (
                            <div className="bg-white/20 text-white rounded-xl h-full flex flex-col items-center justify-center p-8">
                                <h1 className="text-4xl font-bold flex items-center gap-x-3">Oh no! <FaFrown /></h1>
                                <h3 className="text-2xl mt-2">Looks like there are no jobs available...</h3>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {paginatedJobs.map(job => (
                                    <div key={job.id} className="bg-white p-6 rounded-lg flex flex-col justify-between shadow-lg">
                                        <div>
                                            <h3 className="text-xl font-bold text-gray-900">{job.title}</h3>
                                            <p className="text-md text-gray-600 mt-1">{job.company}</p>
                                            <p className="text-sm text-gray-500 mt-1">{job.location}</p>
                                        </div>
                                        <div className="mt-4">
                                            <span className="inline-block bg-purple-100 text-purple-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full">{job.type}</span>
                                            <Link to={`/jobs/${job.id}`} className="inline-block mt-3 text-purple-600 font-semibold hover:text-purple-800">
                                                View Details →
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Bottom View All */}
                <div className="view-all mt-12 pt-8 border-t border-cyan-500">
                    <footer className="flex flex-col md:flex-row items-center justify-between">
                        <h5 className="text-white text-xl mb-4 md:mb-0">Want to see more opportunities?</h5>
                        <Link to="/jobs" className="bg-purple-800 text-white font-bold py-3 px-6 rounded-lg hover:bg-purple-900 transition-colors">
                            View All Jobs
                        </Link>
                    </footer>
                </div>
            </div>
        </section>
    );
};

export default LatestJobs; 